
export const text = `

The sixth and final item to be aware of is anything missing from your videos. They have likely been replaced entirely with subliminal content that you cannot perceive with your mundane senses. If you can perceive them, don't. Remember to always be completely aware of video length, and when in doubt, check your time stamps. Write down the time stamps. If you notice content completely missing from your videos, leave them in a comment below with a link to the video in question.

`